import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileCheckLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.5858 2C14.1162 2 14.6249 2.21071 15 2.58579L19.4142 7C19.7893 7.37507 20 7.88378 20 8.41421V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H13.5858ZM12 4H6V20H18V10H13.5C12.6716 10 12 9.32843 12 8.5V4ZM13.5909 12.6571C13.9814 12.2666 14.6146 12.2666 15.0051 12.6571C15.3956 13.0476 15.3956 13.6808 15.0051 14.0713L11.8938 17.1826C11.4643 17.6122 10.7678 17.6122 10.3382 17.1826L8.9947 15.8391C8.60418 15.4486 8.60418 14.8154 8.9947 14.4249C9.38523 14.0344 10.0184 14.0344 10.4089 14.4249L11.116 15.132L13.5909 12.6571ZM14 4.41421V8H17.5858L14 4.41421Z" })
});
export default SvgFileCheckLine;
